
import './App.css';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import HomeSlider from './components/HomeSlider/HomeSlider';
import Login from './components/Login/Login';
import Navbar from './components/Navbar/Navbar';
import NavbarNew from './components/NavbarNew/NavbarNew';
import Signup from './components/Signup/Signup';
import AllRoutes  from './routes/AllRoutes';
import axios from 'axios';
import { END_URL, IMG_URL,SITE_URL } from './config.js';
import user1 from "./images/profile-no-img.jpg";

import React, { useState, useRef, useEffect } from 'react';
import StaticHeader from './components/StaticHeader/StaticHeader.jsx';

import '@fortawesome/fontawesome-free/css/all.min.css';


function App() {

  const [token, setToken] = useState(false);

  const [Signup, setSignup] = useState(false);

  const user_token = localStorage.getItem('token');

  const [globalTest, setglobalTest] = useState([]);

  const [archMenu, setarchMenu] = useState([]);

  const [menuLink, setmenuLink] = useState([]);

  const [footerLink, setfooterLink] = useState([]);

  const [UserDetail, setUserDetail] = useState([]);

  const [free_test_slug, setfree_test_slug] = useState(false);

  const [profileUrlApp, setprofileUrlApp] = useState(localStorage.getItem("profile_url"));

  const [DashLink, setDashLink] = useState([]);

  const [hasSubscription, setHasSubscription] =  useState([]);

  const [isLoading,setisLoading] = useState(true);

  const [HideNav, setHideNav] = useState(false);

  const [randomTest, setrandomTest] =  useState([]);

  const [quizLinks, setQuizLinks] = useState([]);

  const handleLogin = (status) => {
    // setToken(status);
    setSignup(status);
  };

  const handleSignup = (status) => {
    setToken(status);
  };

  const handleNavHide = (status) => {
      setHideNav(status);
  };

  


  const handleStorage = (flag) => {
    if (flag) {
      const updatedUrl = localStorage.getItem("profile_url");

      if (updatedUrl && updatedUrl.trim() !== "") {
        setprofileUrlApp(updatedUrl);
      } else {
        setprofileUrlApp(null);
      }
    }
  };


  const closeLogin = (status) => {
    setToken(status);

     setSignup(status);
  };


    useEffect(() => {

            const cachedTests = localStorage.getItem("cached_globalTest");
            const cachedTime = localStorage.getItem("cached_globalTest_time");

            if (cachedTests && cachedTime) {
              const parsedTests = JSON.parse(cachedTests);
              setglobalTest(parsedTests);
            }

            const cachedArch = localStorage.getItem("cached_archMenu");
            const cachedArchTime = localStorage.getItem("cached_archMenu_time");

            if (cachedArch && cachedArchTime) {
              const parsedArch = JSON.parse(cachedArch);
              setmenuLink(parsedArch);
            }

            const cachedFooter = localStorage.getItem("cached_footerMenu");

            const cachedFooterTime = localStorage.getItem("cached_footerMenu_time");

            if (cachedFooter && cachedFooterTime) {
              const parsedFooter = JSON.parse(cachedFooter);
              setfooterLink(parsedFooter);
            }

            const cachedQuizLinks = localStorage.getItem("cached_quizLinks");
            const cachedQuizLinksTime = localStorage.getItem("cached_quizLinks_time");

            if (cachedQuizLinks && cachedQuizLinksTime) {
              const parsedQuizLinks = JSON.parse(cachedQuizLinks);
              setQuizLinks(parsedQuizLinks);
            }

            const cachedDash = localStorage.getItem("cached_dash");
            const cachedDashTime = localStorage.getItem("cached_dash_time");

            if (cachedDash && cachedDashTime) {
              const parsedDash = JSON.parse(cachedDash);
              setDashLink(parsedDash);
            }

          const cachedLoginContent = localStorage.getItem("cached_login_contents");

          if (cachedLoginContent) {
              const parsedLoginContent = JSON.parse(cachedLoginContent);
              // setLoginContents(parsedLoginContent);
          }

          axios
            .get(`${END_URL}/menu_links`, {
                headers: {
                    Authorization: `Bearer ${user_token}`,
                },
            })

              .then((response) => {
                
                  const cachedData = cachedTests ? JSON.parse(cachedTests) : null;
                  const isDifferent =
                    JSON.stringify(response.data.tests) !== JSON.stringify(cachedData);

                  if (isDifferent) {
                    setglobalTest(response.data.tests);
                    localStorage.setItem("cached_globalTest", JSON.stringify(response.data.tests));
                    localStorage.setItem("cached_globalTest_time", new Date().toISOString());
                  }

                  const cachedArchData = cachedArch ? JSON.parse(cachedArch) : null;
                  
                  const isDifferentArch =
                      JSON.stringify(response.data.menu_links) !==
                      JSON.stringify(cachedArchData);

                    if (isDifferentArch) {
                      setmenuLink(response.data.menu_links);
                      localStorage.setItem(
                        "cached_archMenu",
                        JSON.stringify(response.data.menu_links)
                      );
                      localStorage.setItem("cached_archMenu_time", new Date().toISOString());
                    }

                  const cachedFooterData = cachedFooter ? JSON.parse(cachedFooter) : null;

                  const isDifferentFooter =
                    JSON.stringify(response.data.footer_menu) !== JSON.stringify(cachedFooterData);

                  if (isDifferentFooter) {
                    setfooterLink(response.data.footer_menu);
                    localStorage.setItem("cached_footerMenu", JSON.stringify(response.data.footer_menu));
                    localStorage.setItem("cached_footerMenu_time", new Date().toISOString());
                  }

                  const cachedQuizLinksData = cachedQuizLinks? JSON.parse(cachedQuizLinks) : null;
                      
                  const isDifferentQuizLinks =JSON.stringify(response.data.quizLinks) !==JSON.stringify(cachedQuizLinksData);
                      
                  if (isDifferentQuizLinks) {

                      setQuizLinks(response.data.quizLinks);

                      localStorage.setItem("cached_quizLinks", JSON.stringify(response.data.quizLinks));

                      localStorage.setItem("cached_quizLinks_time",new Date().toISOString() );
 
                    }

                  const cachedDashData = cachedDash ? JSON.parse(cachedDash) : null;
                  
                  const isDifferentDash =
                      JSON.stringify(response.data.dashboard_menus) !==
                      JSON.stringify(cachedDashData);

                    if (isDifferentDash) {
                      setDashLink(response.data.dashboard_menus);
                      localStorage.setItem(
                        "cached_dash",
                        JSON.stringify(response.data.dashboard_menus)
                      );
                      localStorage.setItem("cached_dash_time", new Date().toISOString());
                    }

                  const cachedLoginData = cachedLoginContent ? JSON.parse(cachedLoginContent) : null;

                  const isDifferentLogin = JSON.stringify(response.data.login_contents) !== JSON.stringify(cachedLoginData);

                  if (isDifferentLogin) {

                      localStorage.setItem("cached_login_contents", JSON.stringify(response.data.login_contents));
                      localStorage.setItem("cached_login_contents_time", new Date().toISOString());
                  }

                  setarchMenu(response.data.arche_tests);

                  setUserDetail(response.data.user);

                  if (response.data.user?.deep_sub) {
                      localStorage.setItem('deep', response.data.user.deep_sub);
                  }
                  
              //  const upsell_test = response.data.tests
              //                     .filter(item => item.up_sell === 1)
              //                     .map(item => item.slug);

                  const upsell_test = response.data.tests.map(item => ({
                      up_sell: item.up_sell,
                      slug: item.slug,
                      dilemma: item.dilemma,
                      type:item.type
                  }));

                  setrandomTest(upsell_test);

                  if(response.data.token_expire)
                  {
                      localStorage.removeItem('token');
                      localStorage.removeItem('user');
                      //  setToken(true);

                  }

              })
              .catch((error) => {
                  console.error("Error fetching tests:", error);

                   if (error.response && error.response.status === 401) {
                        console.warn("Token expired or unauthorized. Logging out...");
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        // setToken(true);
                      }

              });
    }, []);

    useEffect(() => {
      const freeTest = globalTest.find(item => item.type === 'free_test');
        if (freeTest) {
            setfree_test_slug(freeTest.slug);

            localStorage.setItem("url", `${SITE_URL}/${freeTest.link}`);
        }
    }, [globalTest]);

      const GlobalData = {
        user: UserDetail?.ebook_access,
        globalTest: globalTest,
        DashLink: DashLink
      };

      // useEffect(() => {
      //   if (UserDetail) {

      //     setHasSubscription({
      //       user_can_attend: UserDetail?.user_can_attend,
      //       test_user_slugs: UserDetail?.test_user_slugs,
      //     });

      //     setisLoading(false);
      //   }
      // }, [UserDetail]);

     useEffect(() => {

        const freeTestSlugs = globalTest
              ?.filter(item => item.type === "free_test" || item.free_sub == 1)
              ?.map(item => item.slug);

       if (UserDetail && Object.keys(UserDetail).length > 0) {
        
        setHasSubscription({
          user_can_attend: UserDetail?.user_can_attend,
          test_user_slugs: UserDetail?.test_user_slugs,
          deep_sub:UserDetail?.deep_sub,
        });
        setisLoading(false);

      } else if (user_token ==null && freeTestSlugs?.length > 0 ) {
        setHasSubscription({
          user_can_attend: false,
          test_user_slugs: UserDetail?.test_user_slugs, 
          deep_sub:false,
        });
        setisLoading(false);

      }

    }, [UserDetail,user_token,globalTest]);

  return (
    <div className="App"
      style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    minHeight: '150vh' 
  }}
    >
      
      {/* <StaticHeader token={token} free_test_slug={free_test_slug} closeLogin={closeLogin}  profileUrlApp={profileUrlApp} globaltest={GlobalData} archmenu={archMenu} menuLink={menuLink} /> */}

      <NavbarNew HideNav={HideNav} token={token} Signup={Signup} free_test_slug={free_test_slug} closeLogin={closeLogin}  profileUrlApp={profileUrlApp} globaltest={GlobalData} archmenu={archMenu} menuLink={menuLink} /> 
      {/* <main style={{ flex: 1 }}> */}
      <AllRoutes quizLinks={quizLinks} randomTest={randomTest}  menuLink={menuLink} isLoading={isLoading} hasSubscription={hasSubscription} token={user_token}  ProfileChange={handleStorage} userdetail={UserDetail} free_test_slug={free_test_slug} globaltest={GlobalData} onNavHide={handleNavHide}  onLoginChange={handleLogin}  onsignup={handleSignup} />
      {/* </main> */}
      <Footer token={user_token} footerLink={footerLink}   globaltest={GlobalData} onLoginChange={handleLogin} />

    </div>
  );
}

export default App;
